<template>
  <div class="module_assessment">
    <div :key="uuid">
      <div>
        <div style="text-align: justify;">
          <template v-if="institution.overrideAssessmentDescription">
            <span v-html="configuredCnowledgeCheckDescription"></span>
          </template>
          <template v-else>
            <template v-if="assessment.description">
              <span v-html="assessment.description"></span>
            </template>
            <template v-else>
              <span v-html="configuredCnowledgeCheckDescription"></span>
            </template>
          </template>
        </div>
      </div>
      <div>
        <b-button variant="primary" size="lg" :to="{ name: 'assessmentLearnInstructor', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId} }" class="btn_lg" aria-label="Preview Practice Test" v-if="assessment.localPractice">Preview Practice Test</b-button>
        <b-button variant="primary" size="lg" :to="{ name: 'assessmentLearnInstructor', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId} }" class="btn_lg" aria-label="Preview Pre-Diagnostic" v-if="assessment.diagonesticTest">Preview Pre-Diagnostic</b-button>
        <b-button variant="primary" size="lg" :to="{ name: 'assessmentLearnInstructor', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId} }" class="btn_lg" aria-label="Preview Post-Diagnostic" v-if="assessment.diagonesticReportTest">Preview Post-Diagnostic</b-button>
        <b-button variant="primary" size="lg" :to="{ name: 'assessmentLearnInstructor', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId} }" class="btn_lg" aria-label="Preview Knowledge Check" v-if="!assessment.diagonesticReportTest && !assessment.diagonesticTest && !assessment.localPractice">Preview Knowledge Check</b-button>
        <template v-if="course.includeCAI">
        <customize-assessment :courseId="courseId" :entityType="entityType" :entityUuid="uuid" :sessionId="assessment.sessionId"></customize-assessment>
        </template>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import CopyToClipboard from 'vue-copy-to-clipboard'
  import CustomizeAssessment from '../../course/components/customize-assessment/CustomizeAssessment.vue'
  export default {
    name: 'assessmentDetailInstructor',
    components: {
      CopyToClipboard,
      CustomizeAssessment
    },
    props: ['uuid', 'courseId', 'course'],

    data () {
      return {
        attempt: {},
        assessment: {},
        courseCompetency: {},
        isDescriptionReady: false,
        entityType: 'LearningContent',
        status_css: {0: 'not_started', 1: 'in_progress', 2: 'completed', 3: 'failed'}
      }
    },

    computed: {
      ...mapState({
        'institution': state => state.institution.institution
      }),
      configuredCnowledgeCheckDescription () {
        return this.institution.knowledgeCheckDescription.replace('KC_TITLE', this.assessment.title)
      }
    },

    watch: {
      uuid () {
        this.loadAssessmentDetail()
      }
    },

    mounted () {
      this.loadAssessmentDetail()
    },

    methods: {
      ...mapActions([
        'loadAssessment'
      ]),

      loadAssessmentDetail () {
        this.loadAssessment(this.uuid).then((response) => {
          const data = { ...response }
          this.attempt = data.attempt
          this.assessment = data.assessment
        })
      },

      navigateToEdit () {
        this.$router.push('/assessment/' + this.assessment.uuid + '/edit')
      }
    }
  }
</script>

<style scoped>


.score {
    float: left;
    font-size: 23px;
    margin-top: 0px;
}
.score_txt {
    display: inline-block;
    margin-top: 8px;
    margin-left: 8px;
}
.answered {
    float: right;
}
.score_txt, .answered {
	color: rgb(148, 148, 148);
}

.submit button[disabled],
.submit button[disabled]:hover,
.submit button[disabled]:active {
    border: 1px solid #ccc;
    background-color: transparent;
    color: #ccc;
    cursor: not-allowed;
}
.right-panel {
    overflow-y: auto;
    height: calc(100vh - 240px);
}
.icon_state, .icon_state:before {
    width:25px;
    height:25px;
}
.ic_status {
    margin-top: 8px;
    margin-right: 10px;
    float: left;
}
.toc_result_summary {
	margin-bottom: 20px;
}

</style>



// WEBPACK FOOTER //
// src/app/assessment/components/AssessmentDetailInstructor.vue